<template>
  <b-modal
    ref="billModal"
    :title="$t('diagnosis.btns.billItems')"
    centered
    modal-class="bill-modal"
  >
    <b-row>
      <b-col>
        <!--Sample Card-->
        <div class="mx-3">
          <b-row
            style="width:100%"
            class="m-0"
          >
            <b-col class="pl-0 pr-0">
              <div class="gr-card">
                <b-row class="px-3">
                  <b-col class="p-0">
                    <b-row class="pt-2 pl-2 pr-2 pb-1">
                      <b-col>
                        <div class="d-flex align-items-center justify-content-center pb-1">
                          <i
                            class="fal fa-prescription-bottle mr-2 main"
                            aria-hidden="true"
                          />
                          <span>Mockup</span>
                        </div>
                        <hr class="m-0">
                      </b-col>
                    </b-row>
                    <b-row class="pb-1 pl-2 pr-2 gr-card-info">
                      <b-col class="info text-center">
                        <div>
                          <small>{{ $t('diagnosis.grid.sampleGrid.location') }}</small>
                        </div>
                        <div>
                          <span
                            style="font-size:.9rem;color:#303133"
                          >Mockup</span>
                        </div>
                      </b-col>
                      <b-col class="info text-center">
                        <div>
                          <small>{{ $t('diagnosis.grid.sampleGrid.sampleType') }}</small>
                        </div>
                        <div>
                          <span
                            style="font-size:.9rem;color:#303133"
                          >Mockup</span>
                        </div>
                      </b-col>
                      <b-col class="info text-center">
                        <div>
                          <small>{{ $t('diagnosis.grid.sampleGrid.grossingDate') }}</small>
                        </div>
                        <div>
                          <span style="font-size:.9rem;color:#303133">Mockup</span>
                        </div>
                      </b-col>
                      <b-col class="info text-center">
                        <div>
                          <small>{{ $t('diagnosis.grid.sampleGrid.grossingResp') }}</small>
                        </div>
                        <div>
                          <span
                            style="font-size:.9rem;color:#303133"
                          >Mockup</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="px-3 mt-3">
      <b-col>
        <b-card class="py-5 text-center">
          Content here
        </b-card>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="hide"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'BillModal',
    props: {
        sample: Object,
        isCaseValidated: Boolean
    },
    data() {
        return {
            selected: null,
            options: [
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'b', text: 'Opción 3' }
            ]
        }
    },
    methods: {
        show() {
            this.$refs.billModal.show()
        },
        hide() {
            this.$refs.billModal.hide()
        }
    }
}
</script>

<style lang="scss">
.bill-modal .modal-dialog {
  max-width: 55% !important;
}
</style>

<style lang="scss" scoped>
</style>
